import React, { useEffect, useRef, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { FormProvider, useForm, useFormContext, useWatch } from "react-hook-form";

//COMPONENTS
import SelectForm from "../../../components/ComponentesFormularios/SelectForm";
import InputForm from "../../../components/ComponentesFormularios/InputForm";
import RadioButtonForm from "../../../components/ComponentesFormularios/RadioButtonForm";
import SelectFormVirtualize from "../../../components/ComponentesFormularios/SelectFormVirtualize";
import NestedSelectVirtualizeForm from "../../../components/ComponentesFormularios/NestedSelectVirtualizeForm";
import { CalendarForm, CalendarFormRange } from "../../../components/ComponentesFormularios/CalendarForm";

//SERVICES
import { empleadosService } from "src/services/apiEmpleados";
import { vendedorServices } from "src/services/apiVendedores";

//UTILS
import { dateToStringFormat, getFechaToCalendarRange, validateZonaEspejo } from "../../../util/functions";
import { isObject } from "../../../util/is";

//CONSTANTS
import { GlobalConstants } from "../../../data/GlobalConstants";
import { classResponsiveFormDoubleWidth, classResponsiveFormWidthHeader, ERRORFIELDREQUIRED, optionsEstados } from "../../../data/ConstantForm";

//STYLES
import { Colors } from "../../../assets/colors/Colors";

//REDUX
import { useDispatch, useSelector } from "react-redux";

//MODALS
import { modalCRUDService } from "../../../services/modalCRUDService";

const ExisteDocumento = () => {

    const dispatch = useDispatch();
    const { control } = useFormContext();

    const valueDocumento = useWatch({
        control,
        name: "documento"
    })

    useEffect(() => {
        if (valueDocumento?.length >= 7) {

            empleadosService.validateExistsDocument(valueDocumento).then(
                response => {
                    const { status, msg, data } = response;

                    if (status) {

                        if (data[0]?.Existe) {

                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning, message: `Ya Existe el usuario #${valueDocumento}` } });
                        }

                    } else {
                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: msg } });
                    }

                },
                error => {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString() } });
                }
            );
        }
    }, [valueDocumento])

    return (
        <></>
    )
}

const TypeEmpleado = ({ isEditing, isAddMode, stateSelects, properties}) => {

    const { data } = properties
    const dispatch = useDispatch()
    const { setValue, control, formState: { errors } } = useFormContext();
    const [state, setState] = useState({ unavailable: false, required: true})
    const [arrZonaEspejos, setarrZonaEspejos] = useState([])

    const typeEmpleado = useWatch({
        control,
        name: "tipoEmpleado"
    })

    const ref = useRef(typeEmpleado);

    useEffect(() => {
      empleadosService.getZonaEspejosByVendedor({ idAgenteComercial: data.agenteComercial, idPropietario: data.idPropietario, idZona: data.zona}).then(
        response => {
            const { status, msg, data } = response

            if(status){
                setarrZonaEspejos(data)
            }else{
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: msg } });
            }
        }
      )

    }, [])

    useEffect(() => {
        let tipo = isObject(typeEmpleado) ? typeEmpleado.id : typeEmpleado

        if (tipo !== 'VENDEDOR') {
            setState({ ...state, unavailable: true, required: false })

            if (isEditing || !!isEditing) {
                setValue("zona", "")
                setValue("zonaEspejo", "")
                setValue("macrozona", "")
                setValue("idErp", "")
                setValue("modeloAtencion", {id: 0, text: "NO APLICA"})
                setValue("idPortafolio", "")
                setValue("almacen", "")
                setValue("subCanal",{id: "NA", text: "No Aplica", padre: "NA"})
            }
        }
        else {
            setState({ ...state, unavailable: false, required: true })

        }
    }, [typeEmpleado])

    return (
        <>

            <div className="row mx-0 px-0 mt-3 mb-2">

                <CalendarForm inputProps={{ control }} disabled={true} identificador="dtIngreso" label="Fecha Ingreso"
                    required={false} className={`${classResponsiveFormWidthHeader}`} customError={errors.dtIngreso ? ERRORFIELDREQUIRED : null} />

                <SelectFormVirtualize inputProps={{ control }} disabled={!isAddMode} identificador="agenteComercial" label="Agente Comercial"
                    options={stateSelects?.arrAgentesComerciales} required={true} className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.agenteComercial ? ERRORFIELDREQUIRED : null} />

                <InputForm inputProps={{ control }} disabled={!isAddMode} identificador="zona" label="Zona"
                    placeholder="Ej: 6000" required={state.required} type="text" className={`${classResponsiveFormWidthHeader}`} readOnly={state.unavailable}
                    customError={errors.zona ? ERRORFIELDREQUIRED : null} />

                <SelectFormVirtualize inputProps={{ control }} disabled={state.unavailable} identificador="zonaEspejo" label="Zona Espejo" showId={false}
                    options={arrZonaEspejos} required={false} className={`${classResponsiveFormWidthHeader}`} isMulti={true} todoSelect={false}
                    customError={errors.zonaEspejo ? 'Selecciona máximo 4 zonas espejo' : null}/>

            </div>
            <div className="row mx-0 px-0 mt-3 mb-2">

                <SelectFormVirtualize inputProps={{ control }} disabled={!isAddMode} identificador="subCanal" label="Sub Canal"
                    options={stateSelects?.arrSubCanales} required={state.required} className={`${classResponsiveFormWidthHeader}`} readOnly={state.unavailable}
                    customError={errors.subCanal ? ERRORFIELDREQUIRED : null} />

                <NestedSelectVirtualizeForm disabled={!isEditing} keyIdentificador="macrozona" label="Macrozona" required={false}
                    className={classResponsiveFormWidthHeader} options={stateSelects?.arrMacrozonas} readOnly={state.unavailable}
                    customError={errors.macrozona ? ERRORFIELDREQUIRED : null}
                    keyFatherValue="agenteComercial" />

                <InputForm inputProps={{ control }} disabled={!isEditing} identificador="idErp" label="Id Erp"
                    placeholder="Ej: 01" required={false} type="text" className={`${classResponsiveFormWidthHeader}`} readOnly={state.unavailable}
                    customError={errors.idErp ? ERRORFIELDREQUIRED : null} />

                <SelectFormVirtualize inputProps={{ control }} disabled={state.unavailable} identificador="modeloAtencion" label="Modelo Atención"
                    options={stateSelects?.arrModeloAtencion} required={state.required} className={`${classResponsiveFormWidthHeader}`} readOnly={state.unavailable}
                    customError={errors.modeloAtencion ? ERRORFIELDREQUIRED : null} />
                {/* <InputForm inputProps={{ control }} disabled={!isEditing} identificador="modeloAtencion" label="Modelo Atención"
                    placeholder="Ej: M1" required={state.required} type="text" className={`${classResponsiveFormWidthHeader}`} readOnly={state.unavailable}
                    customError={errors.modeloAtencion ? ERRORFIELDREQUIRED : null} /> */}
            </div>

            <div className="row mx-0 px-0 mt-3 mb-2">

                <SelectFormVirtualize inputProps={{ control }} disabled={state.unavailable} identificador="idPortafolio" label="Id Portafolio"
                    options={stateSelects?.arrPortafolios} required={state.required} className={`${classResponsiveFormWidthHeader}`} readOnly={state.unavailable}
                    customError={errors.idPortafolio ? ERRORFIELDREQUIRED : null} />
                {/* <InputForm inputProps={{ control, min: 0, step: "0.01", maxLength: 10 }} disabled={!isEditing} identificador="idPortafolio" label="Id Portafolio"
                    placeholder="Ej: M1" required={state.required} type="text" className={`${classResponsiveFormWidthHeader}`} readOnly={state.unavailable}
                    customError={errors.idPortafolio ? ERRORFIELDREQUIRED : null} /> */}

                <InputForm inputProps={{ control }} disabled={!isEditing} identificador="almacen" label="Almacén"
                    placeholder="Ej: M1" required={state.required} type="text" className={`${classResponsiveFormWidthHeader}`} readOnly={state.unavailable}
                    customError={errors.almacen ? ERRORFIELDREQUIRED : null} />

                <CalendarFormRange inputProps={{ control }} disabled={!isEditing} identificador="dtVigencia" label="Fecha Inicio - Fecha Futuro"
                    className={`${classResponsiveFormDoubleWidth}`} readOnly={state.required} required={state.unavailable}
                    customError={errors.dtVigencia ? ERRORFIELDREQUIRED : null} />

            </div>
        </>
    )
}

const DatosBasicos = React.memo(({ isEditing, isAddMode, properties, stateSelects }) => {

    const { control, formState: { errors } } = useFormContext();

    return (
        <div className="container mx-0 px-0 w-100 mw-100">
            {/* <div className="mx-2 text-center text-muted content-divider divider-form">
                <span className="px-2" style={{ color: Colors.COLOR_SKY_THEME }}>Identificación y clasificación</span>
            </div> */}
            <div className="row mx-0 px-0 mt-3 mb-2">

            { isAddMode &&
                  <ExisteDocumento/>
                }

                <SelectFormVirtualize inputProps={{ control }} showId={false} disabled={!isAddMode} identificador="tipoEmpleado" label="Tipo Empleado"
                    options={stateSelects?.arrTipoEmpleados || []} required={true} className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.tipoEmpleado ? ERRORFIELDREQUIRED : null} />

                <InputForm inputProps={{ control }} identificador="idEmpleado" label="Id Empleado"
                    placeholder="Ej: 10002" type="text" required={false} className={`${classResponsiveFormWidthHeader}`} readOnly={true}
                    customError={errors.idEmpleado ? ERRORFIELDREQUIRED : null} />

                <SelectForm inputProps={{ control }} disabled={!isEditing} identificador="tipoDocumento" label="Tipo Documento"
                    options={stateSelects?.arrTipoDocumentos} required={true} className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.tipoDocumento ? ERRORFIELDREQUIRED : null} />

                <InputForm inputProps={{ control }} disabled={!isEditing} identificador="documento" label="Documento"
                    placeholder="Ej: 34323142343" type="number" required={true} className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.documento ? ERRORFIELDREQUIRED : null} />

            </div>

            <div className="row mx-0 px-0 mt-3 mb-2">

                <InputForm inputProps={{ control }} disabled={!isEditing} identificador="firstName" label="Primer Nombre"
                    placeholder="Ej: Nombre" required={true} type="text" className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.firstName ? ERRORFIELDREQUIRED : null} />

                <InputForm inputProps={{ control }} disabled={!isEditing} identificador="secondName" label="Segundo Nombre"
                    placeholder="Ej: Segundo Nombre" required={false} type="text" className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.secondName ? ERRORFIELDREQUIRED : null} />

                <InputForm inputProps={{ control }} disabled={!isEditing} identificador="surname" label="Primer Apellido"
                    placeholder="Ej: Apellido" required={true} type="text" className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.surname ? ERRORFIELDREQUIRED : null} />

                <InputForm inputProps={{ control }} disabled={!isEditing} identificador="secondSurname" label="Segundo Apellido"
                    placeholder="Ej: Segundo Apellido" required={false} type="text" className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.secondSurname ? ERRORFIELDREQUIRED : null} />
            </div>

            <div className="row mx-0 px-0 mt-3 mb-2">
                <SelectFormVirtualize inputProps={{ control }} disabled={!isEditing} identificador="idPais" label="País" required={true}
                    className={classResponsiveFormWidthHeader} options={stateSelects?.arrPaises}
                    customError={errors.idPais ? ERRORFIELDREQUIRED : null} />

                <NestedSelectVirtualizeForm disabled={!isEditing} keyIdentificador="idDepartamento" label="Departamento" required={true}
                    className={classResponsiveFormWidthHeader} options={stateSelects?.arrDepartamentos}
                    customError={errors.idDepartamento ? ERRORFIELDREQUIRED : null}
                    keyFatherValue="idPais" />

                <NestedSelectVirtualizeForm disabled={!isEditing} keyIdentificador="idCiudad" label="Ciudad" required={true}
                    className={classResponsiveFormWidthHeader} options={stateSelects?.arrCiudades}
                    customError={errors.idCiudad ? ERRORFIELDREQUIRED : null}
                    keyFatherValue="idDepartamento" />

                <InputForm inputProps={{ control }} disabled={!isEditing} identificador="barrio" label="Barrio"
                    placeholder="Ej: Segundo Nombre" required={true} type="text" className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.barrio ? ERRORFIELDREQUIRED : null} />

            </div>

            <div className="row mx-0 px-0">
                <InputForm inputProps={{ control }} disabled={!isEditing} identificador="direccion" label="Dirección"
                    placeholder="Ej: Calle 10" required={true} type="text" className={`w-100`}
                    customError={errors.direccion ? ERRORFIELDREQUIRED : null} />
            </div>

            <div className="row mx-0 px-0 mt-3 mb-2">

                <InputForm inputProps={{ control }} disabled={!isEditing} identificador="fijo" label="Teléfono Fijo"
                    placeholder="Ej: 6353443" type="number" required={false} className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.fijo ? ERRORFIELDREQUIRED : null} />

                <InputForm inputProps={{ control }} disabled={!isEditing} identificador="celular" label="Celular"
                    placeholder="Ej: 3002467589" type="number" required={true} className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.celular ? "Longitud min 10 y max 11" : null} rules={{ minLength: 10, maxLength: 11 }} />

                <InputForm inputProps={{ control }} disabled={!isEditing} identificador="correo" label="Correo"
                    placeholder="Ej: prueba@correo.co" required={true} type="text" className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.correo ? ERRORFIELDREQUIRED : null} />

                <RadioButtonForm inputProps={{ control }} disabled={!isEditing} identificador="estado" options={optionsEstados} required={true}
                    defaultValue="1" label="Estado" className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.estado ? ERRORFIELDREQUIRED : null} />
            </div>


            <div className="mx-2 text-center text-muted     -divider divider-form">
                <span className="px-2" style={{ color: Colors.COLOR_SKY_THEME }}>Otros Datos</span>
            </div>

            <TypeEmpleado isEditing={isEditing} stateSelects={stateSelects} isAddMode={isAddMode} properties={properties}/>

        </div>
    )
})

const FormEmpleadosCRUD = ({ isEditing, properties, isAddMode }) => {

    const { data, params, tableRef } = properties;
    const dispatch = useDispatch();
    const authState = useSelector(state => state.auth)
    const { idUsuario } = authState;
    const generalServicesState = useSelector(state => state.generalServices)
    const methods = useForm({
        defaultValues: {
            ...data,
            dtIngreso: data?.dtIngreso,
            dtVigencia: getFechaToCalendarRange(data?.dtVigenciaIni ? data?.dtVigenciaIni : dateToStringFormat(new Date()), data?.dtVigenciaFin ? data?.dtVigenciaFin : '9999-12-31')
        }
    });
    const { register, handleSubmit, formState: { errors }, control, setValue } = methods;

    useEffect(() => {
        register('zonaEspejo', {validate: value => validateZonaEspejo(value)})
    }, [])


    const onSuccessSubmit = async data => {


        data.dtVigenciaIni = dateToStringFormat(data.dtVigencia[0]);
        data.dtVigenciaFin = dateToStringFormat(data.dtVigencia[1]);
        data.idEstado = 105;
        data.ac = isAddMode && isEditing ? 'C' : isEditing ? 'A' : 'LOCK';
        data.idUsrAuditoria = idUsuario;

        if(data.zonaEspejo){
            let dataAux = '';
            data.zonaEspejo.map((item, index) => {
                if(index == data.zonaEspejo.length - 1){
                    dataAux = `${dataAux}${item.id}`
                }else{
                    dataAux = `${dataAux}${item.id},`
                }
            })
            data.zonaEspejo = dataAux
        }

        let doc = data.documento
        try {
            if (data.ac == 'C') {
                let response = await empleadosService.validateExistsDocument(doc)
                const { status, msg, data } = response;

                if (status) {

                    if (data[0].Existe) {
                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning, message: `Ya Existe el usuario #${doc}` } });
                        return
                    }

                } else {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: msg } });
                }
            }
        } catch (error) {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString() } });
        }

        empleadosService.crudEmpleados(data).then(
            response => {

                const { status, msg, data: datos } = response;

                if (status) {
                    if (datos?.idmsg === 200) {

                        if (isAddMode) {
                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: datos?.txmsg } });

                            tableRef.current.api.applyTransaction({
                                add: [{
                                    id: datos?.idreg,
                                    estado: data.estado,
                                    agenteComercial: data.agenteComercial.text,
                                    zona: data.zona,
                                    tipoTercero: data.tipoEmpleado.text,
                                    documento: data.documento,
                                    nombre: `${data.firstName} ${data.secondName} ${data.surname} ${data.secondSurname}`,
                                    celular: data.celular,
                                    ciudad: data.idCiudad.text,
                                    direccion: data.direccion
                                }]
                            })
                        }
                        else {

                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: datos?.txmsg } });

                            const rowNode = params.api.getRowNode(params.node.id);

                            rowNode.setDataValue("estado", data?.estado);
                            rowNode.setDataValue("agenteComercial", data?.agenteComercial.text);
                            rowNode.setDataValue("zona", data?.zona);
                            rowNode.setDataValue("tipoTercero", data?.tipoEmpleado.text);
                            rowNode.setDataValue("nombre", `${data.firstName} ${data.secondName} ${data.surname} ${data.secondSurname}`,);
                            rowNode.setDataValue("celular", data?.celular);
                            rowNode.setDataValue("ciudad", data?.idCiudad.text);
                            rowNode.setDataValue("direccion", data?.direccion);
                        }

                        if(isEditing == true && isAddMode == true && data.tipoEmpleado.id == 'VENDEDOR' && data.idErp == ''){

                            data['idClaseSolicitud'] = 300;

                            vendedorServices.setVendedor(data, datos?.idreg).then(
                                response =>{
                                    const {status: statusVendedor, data: datosVendedor} = response

                                    if(statusVendedor){
                                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: 'Solicitud ingresada con exito' } });
                                    }else{
                                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: 'Error Solcitud Vendedor' } });
                                    }
                                },
                                error => {
                                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString() } });
                                }
                            )


                        }

                        if(isEditing == true && isAddMode == false && data.tipoEmpleado.id == 'VENDEDOR'){

                            data['idClaseSolicitud'] = 301;
                            vendedorServices.setVendedor(data, datos?.idreg).then(
                                response =>{
                                    const {status: statusVendedor, msg: msgVendedor, data: datosVendedor} = response

                                    if(statusVendedor){
                                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: 'Solicitud ingresada con exito' } });
                                    }else{
                                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: 'Error Solcitud Vendedor' } });
                                    }
                                },
                                error => {
                                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString() } });
                                }
                            )
                        }

                        modalCRUDService.clear();
                    }
                    else {
                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: datos?.txmsg } });
                    }

                } else {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: msg } });
                }

            },
            error => {
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString() } });
            }
        );
    }

    const onErrorSubmit = errors => {
        console.log(errors)
    }

    return (
        <FormProvider {...methods} >
                <header className="px-4 d-flex align-items-center mw-100 mt-2 justify-content-between">

                    <div className="row px-4">
                    </div>

                    <div className="d-flex justify-content-end align-items-center">
                        {isEditing &&
                            <Tooltip title="Guardar" aria-label="guardar">
                                <a onClick={handleSubmit(onSuccessSubmit, onErrorSubmit)}
                                    className="icon-container-actions d-flex">
                                    <div style={{ backgroundColor: Colors.COLOR_GREEN_DARK }} />
                                    <i style={{ color: Colors.COLOR_GREEN_DARK }} className="fas fa-check fa-2x" />
                                </a>
                            </Tooltip>
                        }
                        <Tooltip title="Cancelar" aria-label="cancelar">
                            <a onClick={() => { modalCRUDService.clear() }} className="icon-container-actions d-flex">
                                <div style={{ backgroundColor: Colors.RED_SWITCH_INACTIVE }} />
                                <i style={{ color: Colors.RED_SWITCH_INACTIVE }} className="fas fa-times fa-2x" />
                            </a>
                        </Tooltip>
                    </div>

                </header>
                <DatosBasicos isEditing={isEditing} properties={properties} stateSelects={generalServicesState} isAddMode={isAddMode} />
        </FormProvider>
    )

}

export default FormEmpleadosCRUD;
